import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EResponseBase } from '../data/base/ResponseBase';
import { UtilDto } from '../data/utilDto';
import { environment } from 'src/environments/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class UtilService {

  constructor(private http: HttpClient) { }

  getSurvey(){
    return this.http.get<EResponseBase<UtilDto>>(`${environment.url}/Util`);
  }

  getDeviceDetail(): string {
    if (/Mobi|Android|iPhone|iPad/i.test(navigator.userAgent)) return "Móvil";
    return "PC";
  }

}
